/**
 * Footer component for neutral theme.
 */
import React from 'react';
import './Footer.css';

export const NeutralFooter: React.FC = () => {
  return (
    <footer className="neutral-footer">
      <div className="footer-content">
        <p className="footer-text">
          Copyright 2025 Rob Kooper
        </p>
      </div>
    </footer>
  );
};

